import { EntityFormModel } from "../../models/entity.model";
import AlertMessage from "../common/AlertMessage";
import InputLabel from "../common/InputLabel";
import SimpleEditor from "../common/SimpleEditor";
import './index.css'

interface EntityFormProps {
  entityForm: EntityFormModel
  setEntityForm: (e: any) => void
  action?: string
  errors?: string[]
  editable?: boolean
}

const EntityForm: React.FC<EntityFormProps> = ({
  entityForm,
  setEntityForm,
  action = 'view',
  errors = [],
  editable = true
}) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEntityForm({
      ...entityForm,
      [event.target.name]: event.target.value
    });
  }

  return <>
    <div className="entities-action-form">
      <div className="entities-action-form-item">
        <InputLabel
          label='Nombre'
          name='name'
          value={entityForm.name}
          disabled={action === 'view'}
          onChange={handleChange}
          required
          error={errors.includes('name') && entityForm.name.length === 0}
        />
      </div>

      {(action === 'view' || action === 'edit') && (<>

        <div className="entities-action-form-item">
          <InputLabel
            label='Fecha de Creación'
            name='created_date'
            value={entityForm.created_date}
            disabled
            onChange={handleChange}
          />
        </div>
      </>)}

      <div className="entities-action-form-description">
        <SimpleEditor
          name='description'
          label='Descripción'
          value={entityForm.description}
          handleChange={handleChange}
          disabled={action === 'view'}
        />
      </div>

      {(!editable && action === 'view') && (
        <div className="entities-action-form-info-noneditable">
          <AlertMessage
            message="Esta entidad no se puede editar"
            severity="info"
          />
        </div>
      )}
    </div>
  </>
}

export default EntityForm